import { Helmet } from "react-helmet-async";

const SITE_URL = "https://foodiecrave.app";

export const Seo = ({ title, description, path = "", ogTitle, ogDescription, robots }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={`${SITE_URL}${path}`} />
    <meta
      name="robots"
      content={robots || "index, follow, max-image-preview:large, max-snippet:-1"}
    />
    <meta property="og:title" content={ogTitle || title} />
    <meta property="og:description" content={ogDescription || description} />
    <meta property="og:url" content={`${SITE_URL}${path}`} />
    <meta name="twitter:title" content={ogTitle || title} />
    <meta name="twitter:description" content={ogDescription || description} />
  </Helmet>
);
